<template>
    <div id="page">
        <Navbar :title="'Regnskap'" :backBtn="'Home'"/>
        
        <div class="page-content header-clear-medium">
            <div class="travel-list-container">
                <h2 class="bold center-text">Regnskap</h2>
                <div class="divider divider-margins"></div>
                <div class="landing-icons color-theme">
                    <a href="https://eaccounting.vismaonline.com">
                                <i class="bg-red2-dark shadow-icon-large fas fa-calculator"></i>
                                <em class="color-theme">Visma</em>
                            </a>
                            <a href="https://www.dnb.no/bedrift">
                                <i class="bg-mint-dark shadow-icon-large fas fa-university"></i>
                                <em class="color-theme">DNB</em>
                            </a>
                            <a href="https://www.altinn.no/">
                                <i class="bg-blue2-dark shadow-icon-large fas fa-inbox"></i>
                                <em class="color-theme">Altinn</em>
                            </a>
                    <div class="clear"></div>
                </div>
            </div>
        </div>
        <div class="menu-hider"></div>
    </div>
</template>

<script>
import Navbar from '@/components/layouts/Navbar'

export default {
    name: 'Accounting',
    components:{
        Navbar
    },
    data(){
        return{

        }
    }
}
</script>

<style>

</style>